import React, { useEffect, useState, useCallback } from 'react';

const Header = () => {
  const [open, setOpen] = useState(false);

  const closeMenu = useCallback(() => setOpen(false), []);
  const toggleMenu = () => setOpen((v) => !v);

  const navigate = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });

    document.querySelectorAll('.menu a').forEach((a) => a.classList.remove('active'));
    const link = document.querySelector(`[data-link="${id}"]`);
    if (link) link.classList.add('active');

    // close menu on mobile after navigation
    closeMenu();
  };

  // Close the menu when pressing Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') closeMenu();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [closeMenu]);

  // If resized back to desktop, ensure menu is closed (since desktop menu is always visible)
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 880) closeMenu();
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [closeMenu]);

  return (
    <header>
      <div className="container nav">
      <a href="#home" className="brand">Elegant  <strong>Technologies FZ LLE</strong></a>


        {/* Mobile toggle button */}
        <button
          className="hamburger"
          aria-label="Toggle navigation"
          aria-controls="site-menu"
          aria-expanded={open}
          onClick={toggleMenu}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        <nav id="site-menu" className={`menu ${open ? 'open' : ''}`}>
          <a href="#home" data-link="home" onClick={(e)=>{e.preventDefault();navigate('home')}} className="active">Home</a>
          <a href="#about" data-link="about" onClick={(e)=>{e.preventDefault();navigate('about')}}>About Us</a>
          <a href="#services" data-link="services" onClick={(e)=>{e.preventDefault();navigate('services')}}>Services</a>
          <a href="#testimonials" data-link="testimonials" onClick={(e)=>{e.preventDefault();navigate('testimonials')}}>Testimonials</a>
          <a href="#contact" data-link="contact" onClick={(e)=>{e.preventDefault();navigate('contact')}}>Contact Us</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
